export enum LocationType {
  IRL = "IRL",
  REMOTE = "REMOTE",
}
